<template>
  <div id="topNav" ref="delete" :class="{overflow:hidden}">
    <div :class="['width' ,'clearfix',{en}]" style="position:relative">
      <div class="logo fl">
        <h1></h1>
      </div>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo fr"
        mode="horizontal"
        :unique-opened="uniqueOpened"
        menu-trigger="hover"
        @open="handleOpen"
        @close="handleClose"
        @select="handleSelect"
        router
      >
        <el-menu-item index="/index">
          <span>{{$t('message.Home')}}</span>
        </el-menu-item>
        <el-menu-item index="/companIntroduction">
          <span>{{$t('message.CompanyIntroduction')}}</span>
        </el-menu-item>
        <el-menu-item index="/corporateCulture">
          <span>{{$t('message.CompanyCulture')}}</span>
        </el-menu-item>
        <el-menu-item index="/newsInformation">
          <span>{{$t('message.News')}}</span>
        </el-menu-item>
        <el-menu-item index="/contactUs">
          <span>{{$t('message.ContactUs')}}</span>
        </el-menu-item>
        <el-submenu
          index="lang"
          class="fr langSwitch"
          :popper-class="en? 'langEn':'lang' "
          ref="langSwitch"
        >
          <template slot="title">
            {{$t('message.Language')}}
            <div :class="{langArrow,langselected}"></div>
          </template>
          <el-menu-item class="langItem" attr="EN" style="display:none">EN</el-menu-item>
          <el-menu-item class="langItem" attr="CN">简</el-menu-item>
          <el-menu-item class="langItem" attr="TW">繁</el-menu-item>
        </el-submenu>
        <el-submenu
          index="platform"
          class="fl platSwitch"
          :popper-class="en? 'platformEn':'platform'"
          ref="platSwitch"
        >
          <template slot="title">
            {{$t('message.CeBaRelatedPlatform')}}
            <div :class="{platformArrow,platformselected}"></div>
          </template>
          <el-menu-item
            attr="zbs"
            class="platformItem"
          >{{$t('message.InvoiceAndQualityCertificateQueryPlatform')}}</el-menu-item>
          <el-menu-item
            attr="cncaq"
            class="platformItem"
          >{{$t('message.ElectronicSignatureDocume')}}</el-menu-item>
          <el-menu-item
            attr="yz"
            class="platformItem"
          >{{$t('message.OnlineVerificationPlatformFor')}}</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: "/index",
      uniqueOpened: true,
      hidden: false,
      platformArrow: true,
      langArrow: true,
      platformselected: false,
      langselected: false,
      en: false,
      view: 0,
      platformWidth: 0
    };
  },
  methods: {
    handleSelect(index, indexpath, element) {
      switch (element.$attrs.attr) {
        case "EN":
          this.$i18n.locale = "EN";
          this.en = true;
          const lang = document.querySelector(".lang");
          if (lang) {
            lang.className = "langEn";
          }
          break;
        case "CN":
          this.$i18n.locale = "CN";
          this.en = false;
          break;
        case "TW":
          this.$i18n.locale = "TW";
          this.en = false;
          break;
        case "zbs":
          window.open("http://www.qdrhome.com");
          break;
        case "cncaq":
          window.open("http://www.cncaq.com/");
          break;
        case "yz":
          window.open("http://yz.cnca.cn/ver-ep/ve/v/pdfveri.jsp");
          break;
      }
      this.platformselected = false;
      this.langselected = false;
    },
    handleOpen(e, b) {
      if (e === "lang") {
        var langSwitch = this.$refs.langSwitch.$refs.menu;
        this.langselected = true;
      } else this.langselected = false;
      if (e === "platform") {
        var plateSwitch = this.$refs.platSwitch.$refs.menu;
        this.platformselected = true;
      } else this.platformselected = false;
    },
    handleClose(e, b) {
      if (e === "lang") this.langselected = false;
      if (e === "platform") this.platformselected = false;
    }
  },
  created() {
    var path = location.hash.split("/")[1];
    this.activeIndex = "/" + path;
    this.view = document.body.clientWidth;
  },
  mounted() {
    var parent = this.$refs.delete;
    var element = parent.getElementsByClassName("el-icon-arrow-down");
    element[0].className = "";
    element[0].className = "";
  },
  watch: {
    "$route.path"(to, from) {
      var path = to.split("/")[1];
      this.activeIndex = "/" + path;
      if (to === "/agreement" || to === "/privacyPolicy") {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    }
  }
};
</script>
<style scoped>
#topNav {
  box-sizing: border-box;
  width: 100%;
  height: 94px;
  border-bottom: 1px solid #ccc; /* no */
}
.overflow {
  overflow: hidden !important;
}
.logo {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.logo h1 {
  width: 359px;
  height: 54px;
  background-image: url("../../assets/images/测吧logo@2x.png");
  background-size: 100%;
}
.border-right {
  border-right: 1px solid #e5e5e5 !important; /* no */
}

.el-menu-demo {
  height: 92px;
  border: none;
  overflow: hidden;
}

#topNav .en .el-menu-item {
  display: table;
}
#topNav .en .el-menu-item span {
  display: table-cell;
  vertical-align: middle;
  word-wrap: break-word;
  white-space: normal;
  line-height: 30px;
}

#topNav .el-menu-item {
  width: 110px;
  height: 92px;
  padding: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 92px;
  border: none;
  color: #333333;
}

.width {
  width: 1360px;
  position: relative;
}

.is-active {
  border-bottom: none !important;
}
#topNav .el-menu--horizontal > .el-menu-item.is-active {
  color: #ff6600;
}
#topNav .el-submenu >>> .el-submenu__title {
  position: relative;
  font-size: 16px;
  height: 94px !important;
  line-height: 94px !important;
  color: #333333;
  border: none !important;
}
.fr.el-submenu >>> .el-submenu__title {
  padding: 0 20px;
  border: none;
  margin: 0 20px 0 50px;
}
.en .fl.el-submenu >>> .el-submenu__title {
  padding: 0 20px;
  border: none;
  margin: 0 0;
}
.fl.el-submenu >>> .el-submenu__title {
  padding-right: 17px;
  border: none;
}
.platformArrow,
.langArrow {
  position: absolute;
  right: 0;
  top: 46px;
  width: 0;
  border-top: 5px solid #333333;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}
/* .platformselected,
.langselected {
  border-top: 5px solid #0052d9;
} */

.platformItem {
  height: 28px !important;
  line-height: 28px !important;
  text-align: right;
  font-size: 14px;
  color: #0052d9;
  margin-right: 0 !important;
  padding: 0 14px 0 39px !important;
}
.platformEn .platformItem {
  font-size: 14px;
  margin: 0;
  padding: 0 5px;
}

.langItem {
  width: 60px;
  height: 28px !important;
  line-height: 28px !important;
  text-align: center;
  font-size: 14px;
  color: #0052d9;
  margin-right: 0 !important;
}
/* #topNav .el-submenu.is-opened >>> .el-submenu__title {
  color: #0052d9;
} */
</style>
<style>
.platform .el-menu--popup-bottom-start {
  margin: 0;
  padding: 0;
  min-width: 0;
  overflow: hidden;
}
.platformEn .el-menu--popup-bottom-start {
  margin: 0;
  background-color: #47494a;
  padding: 0;
}

.lang .el-menu--popup-bottom-start,
.langEn .el-menu--popup-bottom-start {
  margin: 0;
  padding: 0;
  width: 60px;
  min-width: 0;
  border-radius: 4px;
  overflow: hidden;
}

.el-menu-item,
.el-submenu__title {
  line-height: 36px;
}
.platform {
  left: auto !important;
  right: 400px !important;
  border-radius: 4px;
  overflow: hidden;
}
.platformEn {
  left: auto !important;
  right: 400px !important;
  border-radius: 4px;
  overflow: hidden;
}
.el-menu-item.langItem,
.el-menu-item.platformItem {
  background-color: #47494a !important;
}
.lang {
  left: auto !important;
  right: 290px !important;
}
.langEn {
  left: auto !important;
  right: 290px !important;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #fff !important;
}

.el-menu--popup-bottom-start .el-menu-item:hover {
  color: #ff6600 !important;
  background-color: #f3f2f2 !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/Header.vue